/* eslint-disable class-methods-use-this */
import Model from './Model';
import FrameworkCategory from './FrameworkCategory';

export default class ReportItem extends Model {
    // noinspection JSMethodCanBeStatic
    resource() {
        return 'report_items';
    }

    async getFrameworkCategory() {
        return new FrameworkCategory(this.frameworkCategory);
    }
}
